// eslint-disable-next-line import/prefer-default-export
export const fileName = function fileName(name) {
  if (!name) {
    return '';
  }
  return name.substring(0, name.lastIndexOf('.'));
};
